const defaultState = {
  isRequesting: false,
  code: null,
  error: false,
};

export default function shifts(state = defaultState, action) {
  switch (action.type) {
    case 'SHIFT_REQUESTED':
      return Object.assign({}, state, {
        isRequesting: true,
        code: null,
        error: false,
      });
    case 'SHIFT_CONFIRMED':
      return Object.assign({}, state, {
        isRequesting: false,
        code: action.code,
        error: false,
      });

    case 'SHIFT_FAILED':
      return Object.assign({}, state, {
        isRequesting: false,
        code: null,
        error: true,
      });

    default:
      return state;
  }
}
